module.exports = "//static.hsappstatic.net/LoginUI/static-1.15982/img/SUI_mobile.svg"